import { Component, Input, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { AgGridI } from '../../ag-grid/ag-grid.model';
import { AgCustomHeaderComponent } from './../../../../shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { CommonService } from '../../../services/common.service';
import { TabsService } from '../../tabs/tabs.service';
import { AgGridImportCommonPreview } from '../common-preview-tab-model';

@Component({
  selector: 'app-common-preview-tab',
  templateUrl: './common-preview-tab.component.html',
  styleUrls: ['./common-preview-tab.component.scss']
})
export class CommonPreviewTabComponent implements OnInit {
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    };
  flexHeight;
  public defaultColDef: ColDef = {
    resizable: true,
   // maxWidth:350
  };
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  dataModel: AgGridI;
  isLoading: boolean = false;
   gridApi;
   gridColumnApi;
@Input() data:any = {}

  constructor(public commonService: CommonService,public tabsService: TabsService,) { }

  ngOnInit(): void {
    this.tabsService.onSubNavChanged.subscribe((url=>{
      if(url!== undefined){
        this.dataModel = this.data?.previewData?.dataModel ?? AgGridImportCommonPreview;
      }
    }));

    this.dataModel = this.data?.previewData?.dataModel ?? AgGridImportCommonPreview;
    this.commonService.headerHeight.subscribe(res => {
      this.flexHeight = "calc(100vh - 290px - " + res + "px" + ")"

    })

  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

}
